module.exports = __webpack_public_path__ + "img/1564964322.13dd5fef.jpg";